import { round } from '@/utils/math/round';
import { StoreState } from '@/redux/types';
import { isMdsPriceStrategy } from './isMdsPriceStrategy';

export function convertPriceIfNeeded(value: number, state: StoreState): number {
  const {
    context: { currency: valueCurrency, priceStrategy },
    currency: displayCurrency,
    exchangeRates,
  } = state.core;

  if (
    isMdsPriceStrategy(priceStrategy) &&
    displayCurrency.id !== valueCurrency.id &&
    Boolean(exchangeRates)
  ) {
    const sourceRate = exchangeRates[valueCurrency.id];
    const targetRate = exchangeRates[displayCurrency.id];

    const convertedPrice = (value / sourceRate) * targetRate;
    return round(convertedPrice, displayCurrency.decimalCount);
  }

  return value;
}
